/**
 * AiNarrativeFallback
 *
 * Rendered in place of an AI-generated narrative (ExecutiveSummary / GroupSummary)
 * when AI Insights are disabled or unavailable. The IT Report is used as a
 * handover-grade source of truth, so sections must never silently disappear:
 * each on-screen metric block already carries its own deterministic
 * "What this means" copy, and this note simply makes the absence of the AI
 * narrative explicit rather than leaving an unexplained gap.
 *
 * It is intentionally lightweight and clearly labelled as non-AI so readers are
 * never misled into thinking an automated analysis ran.
 */
const AiNarrativeFallback = ({ title, variant = 'group' }) => {
  const isExecutive = variant === 'executive';

  const wrapperStyle = isExecutive
    ? { marginBottom: 12 }
    : { marginTop: 4, marginBottom: 0, padding: 12 };

  return (
    <div className="dashboard-card insight-card insight-card--fallback" style={wrapperStyle}>
      {isExecutive ? (
        <h2 className="insight-title" style={{ marginTop: 0, fontSize: 18 }}>Executive Summary</h2>
      ) : (
        <div
          className="insight-subtitle"
          style={{ fontSize: 13, textTransform: 'uppercase', color: '#666', marginBottom: 6 }}
        >
          {title} Summary
        </div>
      )}
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: '#555' }}>
        <span aria-hidden="true" style={{ fontSize: 14, lineHeight: '18px' }}>ℹ️</span>
        <div>
          AI Insights are currently disabled, so no automated written analysis is included for this section.
          The figures and the “What this means” notes shown above are calculated directly from live data and
          remain accurate. Enable AI Insights in <em>Settings → Secrets</em> to add narrative commentary here.
        </div>
      </div>
    </div>
  );
};

export default AiNarrativeFallback;
